'use client'

import { useEffect } from 'react'

// Strips the `dark` class from <html> and <body> on mount and on every render
// pass. The auth pages (/login, /logout) are not designed for dark mode — the
// AuthPortal logo and form contrast assume a light background. Without this,
// users who previously visited a page that set <html class="dark"> (e.g. blog
// posts via useDarkMode) carry that class into /login and the logo becomes
// invisible against a black background.
//
// This is the sole mechanism keeping the auth pages light. `dark` is only ever
// applied after hydration (useDarkMode's effect reads localStorage/system pref),
// so a synchronous pre-paint script in the layout <head> had nothing to strip on
// a hard load and didn't run on a soft nav anyway — this effect handles both,
// including any late writer that toggles `dark` after hydration.
export default function ForceLightTheme() {
  useEffect(() => {
    document.documentElement.classList.remove('dark')
    document.body.classList.remove('dark')
  })

  return null
}
